import { showModalDialogCloseButton, hideModalDialogCloseButton } from '@/utils/modal-utils.js';

const state = {
  tileSubmitting: false, // for setup, address, payment method module submitting
  submitCheckLoading: false, // for place order cta
  preCheckLoading: false,
  tos: [], // agreements to be checked before submiting
}

const getters = {
  // One of the modules is being submitted (signUp/address/payment)
  tileSubmitting: (state) => state.tileSubmitting,
  // placing an order
  submitCheckLoading: (state) => state.submitCheckLoading,
  preCheckLoading: (state) => state.preCheckLoading,
  isTosChecked: ({ tos }) => {
    return tos.every(x => x.is);
  },
  isARLChecked: ({ tos }) => {
    return tos.some(x => x.is && x.key === 'ARL');
  },
  hasOtherUncheckedTerms: ({ tos }) => {
    return tos.some(x => !x.is && x.key !== 'ARL');
  }
}

const mutations = {
  toggleTileSubmitting(state, data) {
    state.tileSubmitting = data;
  },
  toggleSubmitCheckLoading(state, data) {
    // in modal iframe case, when submitCheckLoading is true, we should hide outter container close button
    if (window?.$context?.is?.modal) {
      data ? hideModalDialogCloseButton() : showModalDialogCloseButton();
    }
    state.submitCheckLoading = data;
  },
  togglePreCheckLoading(state, data) {
    state.preCheckLoading = data;
  },
  setTosChecked({ tos }, data) {
    const found = tos.find(x => x.key === data.key);
    if (found) return found.is = data.is;
    tos.push(data);
  },
  removeTos({ tos }, key) {
    const index = tos.findIndex(x => x.key === key);
    if (index === -1) return;
    tos.splice(index, 1);
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
